export default __webpack_public_path__ + "static/media/puppet-samurai-logo.a5501678.png";